export default {
  namespaced: true,

  state: {
    notification: {}
  },

  mutations: {
    notify (state, value) {
      state.notification = value || {}
    },
    clearNotification (state) {
      state.notification = {}
    }
  }
}
